import { useState } from 'react';

/** @deprecated */
// TODO: Refactor all modals to use redux and remove this hook
export const useModal = () => {
  const [isOpen, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return { isOpen, openModal, closeModal };
};
